<template>
  <div>
    <app-notification :title="'קרתה תקלה… '"
                      :text="'הצוות שלנו עובד לתקן אותה מהר! נשלח לך לינק לתזרים מעודכן ברגע שהיא תיפתר.'"
                      :icon-type="'danger'"/>
  </div>
</template>

<script>
import Segment from '../../../../../../../Segment';
import AppNotification from '../AppNotification.vue';

export default {
  name: 'SystemBugNotification',
  components: {
    AppNotification,
  },
  async created() {
    Segment.trackUserGot('SystemBugNotificationShown');
  },
};

</script>

<style lang="scss" scoped>
</style>
